__turbopack_context__.v({
  "content": "ProductListingPage-module__mg947W__content",
  "filterTabs": "ProductListingPage-module__mg947W__filterTabs",
  "first": "ProductListingPage-module__mg947W__first",
  "gridList": "ProductListingPage-module__mg947W__gridList",
  "root": "ProductListingPage-module__mg947W__root",
});
